import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiInputCheckboxComponent } from './eui-input-checkbox.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiInputCheckboxComponent,
    ],
    exports: [
        EuiInputCheckboxComponent,
    ],
})
export class EuiInputCheckboxModule { }
